/* eslint-disable require-atomic-updates */
import ReverMedia from 'rever-media-sdk'
import store from '@/store/index.js'
import config from '@/config.js'

let reverMediaClient = null

async function initReverMediaClient() {
  const test = await store.access.getToken()
  const test2 = await store.access.getOrganizationId()

  if (reverMediaClient) {
    return reverMediaClient
  }

  reverMediaClient = await ReverMedia.init({
    reverURL: `${config.api}/api/v1`,
    reverToken: test,
    organizationId: test2,
    azureStorageToken: null,
  })

  return reverMediaClient
}

export async function getBase64(mediaObject, size) {
  const client = await initReverMediaClient()
  return await client.fetchBase64(mediaObject, {
    size,
  })
}

export async function getImageSrc(mediaObject, size) {
  const client = await initReverMediaClient()
  return client.fetchToLocalPath(mediaObject, {
    size,
  })
}
